import { Button, Modal, NumberInput, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './EditOccurrenceAmountModal.module.scss';
import { Props } from './EditOccurrenceAmountModal.types';

const EditOccurrenceAmountModal = ({
  open,
  onClose,
  title,
  initialAmount,
  loading,
  onConfirm,
}: Props) => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState(initialAmount);

  useEffect(() => {
    if (open) setAmount(initialAmount);
  }, [open, initialAmount]);

  return (
    <Modal opened={open} onClose={onClose} title={title}>
      <Text size="sm" c="dimmed" mb="md">
        {t(
          'expenses.editOccurrenceAmount.description',
          "Cette occurrence n'a pas encore été générée. Le montant que vous définissez ici sera utilisé au lieu du montant habituel de la dépense récurrente."
        )}
      </Text>
      <NumberInput
        label={t('common.amount', 'Montant')}
        value={amount}
        onChange={value => setAmount(typeof value === 'number' ? value : 0)}
        min={0}
        decimalScale={2}
        suffix=" €"
        autoFocus
      />
      <div className={styles.buttons}>
        <Button variant="outline" onClick={onClose} disabled={loading}>
          {t('common.cancel', 'Annuler')}
        </Button>
        <Button onClick={() => onConfirm(amount)} loading={loading}>
          {t('common.save', 'Enregistrer')}
        </Button>
      </div>
    </Modal>
  );
};

export default EditOccurrenceAmountModal;
